export default __webpack_public_path__ + "static/media/help_noPhotoUser_mail_confused.29e1a030.png";